/**
 * 🔴 US-AIV2-0110 S18 (@UC0262) — SỐ TIẾNG VIỆT VIẾT BẰNG CHỮ ⇒ CHỮ SỐ, ở ĐẦU bộ đổi tiền.
 *
 * Nguồn ngữ pháp (port, không chép mã): NVIDIA NeMo-text-processing — inverse text normalization tiếng Việt,
 * `nemo_text_processing/inverse_text_normalization/vi/taggers/cardinal.py` + `vi/data/numbers/{digit,digit_special,
 * hundred,teen,thousands,ties,zero}.tsv` + `vi/data/magnitudes.tsv`, commit `ddadfb2a38d2bc6b8cc6232c4f915eb60f500688`
 * (https://github.com/NVIDIA/NeMo-text-processing). Giấy phép **Apache License 2.0** (Copyright NVIDIA CORPORATION) —
 * bảng từ vựng dưới đây là bản chuyển thể của các file `.tsv` đó; ngữ pháp WFST (pynini, Python) được viết lại thành bộ
 * phân tích tất định bằng TypeScript. Bộ ca kiểm tra port (nguyên văn) ở `vi-number-words.test.ts`.
 *
 * ═══ MỘT CƠ CHẾ, KHÔNG BỘ ĐỌC TIỀN THỨ HAI ═══
 * File này KHÔNG quyết định số tiền. Nó chỉ VIẾT LẠI cụm số chữ thành dạng chữ số mà người gõ số sẽ gõ, rồi
 * `extractMoneyCandidates` · `parseVndAmountMinor` chạy trên chuỗi đã viết lại — nên MỌI luật an toàn đã có (năm, danh từ
 * đếm, ngày, đuôi số ghép, «rưỡi», "N trăm" trần, nhiều giá trị) tự áp, không viết lại một luật nào:
 *   · "hai trăm nghìn" ⇒ "200 nghìn" · "một triệu hai trăm nghìn" ⇒ "1200 nghìn" (MỘT giá trị) · "năm trăm k" ⇒ "500 k"
 *   · "hai trăm" (không đơn vị theo sau) ⇒ "2 trăm" ⇒ luật QĐ-10 cũ: hỏi, 200.000 mời trước — KHÔNG ra 200
 *   · "một triệu hai" ⇒ "1 triệu 2" · "một triệu hai trăm" ⇒ "1 triệu 2 trăm" ⇒ luật đuôi ghép cũ: hỏi, y như "1tr2"
 *   · "hai triệu rưỡi" ⇒ "2 triệu rưỡi" ⇒ luật «rưỡi» cũ: hỏi
 *   · "hai mươi" ⇒ "20" · "ba" (không từ bậc, không đơn vị) ⇒ KHÔNG đổi ⇒ luật "số trần <4 chữ số không phải tiền" cũ
 *   · "ba chục nghìn" ⇒ "30 nghìn" · "một chục k" ⇒ "10 k" · "ba chục" trần ⇒ "3 chục" ⇒ luật cũ hỏi, y như "3 chục" gõ số
 *   · "1tr hai" · "1 triệu hai" · "2tr tư" ⇒ "1tr 2" · "1 triệu 2" · "2tr 4" ⇒ luật đuôi ghép cũ hỏi (develop từng ra 1.000.000 tự tin);
 *     trừ từ số là SỐ LƯỢNG của danh từ theo sau ("1tr hai người", "200k hai bạn") hoặc "năm" là danh từ ("500k năm nay").
 *     Câu không dấu: chỉ khi từ số đứng CUỐI cụm từ ("300k sau do" = sau đó; "300k tu quy" = từ quỹ).
 *
 * ═══ Cụm KHÔNG đọc được không được VÔ HÌNH (rà vòng 2) ═══
 * Từ ước lượng + bậc/đơn vị ("vài trăm nghìn", "nửa nghìn", "mấy chục k") hoặc + cụm số ("vài ba trăm nghìn") ⇒ `unreadRun`
 * — MẶC ĐỊNH, trừ khi ngay sau là danh từ ĐẾM trong tập đóng ("hàng chục người", "vài trăm lượt" — rà vòng 3–4):
 * người gọi coi câu là MƠ HỒ nếu còn số khác, KHÔNG ĐỌC ĐƯỢC nếu không — không bao giờ chọn số còn lại.
 *
 * ═══ Ba chỗ Goppy CHẶT HƠN NeMo (tiền: hỏi, không đoán — CLAUDE.md §4) ═══
 *   1. Dạng RÚT GỌN mà NeMo đọc được nhưng có hai cách hiểu khi nói về tiền ⇒ cả cụm bị đánh dấu MƠ HỒ (`ambiguous`):
 *      hàng chục thiếu "mươi" bằng chữ số thường ("sáu bảy trăm nghìn" = 600–700 nghìn hay 670 nghìn?) · "trăm" + một
 *      chữ số ("một trăm hai" = 120 hay 102?).
 *      Rút gọn bằng dấu hiệu riêng của hàng đơn vị sau hàng chục — "mốt · tư · lăm" ("hai mốt", "ba tư", "hai lăm") —
 *      KHÔNG mơ hồ (không ai nói khoảng "hai–mốt") ⇒ đọc.
 *   2. Đuôi sau "triệu"/"tỷ" không mở bằng số 0 tường minh ("không trăm", "linh", "lẻ"), và một chữ số trần sau "nghìn"
 *      ("một ngàn chín" = 1.900 hay 1.009?) ⇒ giữ dạng đuôi ghép ("1 ngàn 9") để luật cũ hỏi: "một triệu hai trăm năm
 *      mươi" hay được nói với nghĩa 1.250.000 (bỏ chữ "nghìn").
 *   3. Không đọc số âm ("âm", "trừ"), bậc ghép ("nghìn tỷ") ⇒ để nguyên. Số thập phân bằng chữ CHỈ một dạng (S29, dưới).
 *
 * ═══ 🔴 S29 (@UC0281) — THẬP PHÂN BẰNG CHỮ và "NỬA" ═══
 *   · "A phẩy/chấm D [D] <bậc>" ⇒ "A,DD <bậc>" (A = một số 0..999 đọc trọn, D = MỘT chữ số mỗi từ — cách đọc từng chữ số sau
 *     dấu phẩy): "một phẩy năm triệu" ⇒ "1,5 triệu" · "một phẩy hai lăm triệu" ⇒ "1,25 triệu". Bậc có thể là đơn vị theo sau
 *     ("hai phẩy tư k" ⇒ "2,4 k"). Rồi CÙNG luật dấu phân cách của chữ số (`vi-normalizer.ts`) quyết — không luật thứ hai.
 *   · "1 phẩy 5 triệu" (chữ số) ⇒ "1,5 triệu".
 *   · Mọi dạng khác quanh "phẩy"/"chấm" đứng GIỮA hai số ⇒ CẢ CỤM mơ hồ, không để nửa sau được đọc riêng: trộn chữ với chữ số
 *     ("một phẩy 5 triệu"), "rưỡi"/"nửa" sau dấu, phần thập phân có từ bậc ("một phẩy năm trăm"), phần nguyên có bậc ("hai
 *     triệu một phẩy năm"), ≥3 chữ số thập phân. develop từng đọc "một phẩy năm triệu" và "1 phẩy 5 triệu" thành 5.000.000.
 *   · Không bậc/đơn vị theo sau ("một phẩy năm chứ không phải hai triệu") ⇒ giữ nguyên chữ nhưng là CỤM CHƯA ĐỌC (`unreadRun`):
 *     câu còn số tiền khác ⇒ hỏi. "cham" không dấu (= chậm) luôn là dấu YẾU ⇒ mơ hồ; "phay"/"cham" nhận cả trong câu có dấu.
 *   · "nửa triệu/tỷ/tỉ/củ/tr" ⇒ "0,5 …" — trừ khi trước là một số ("một nửa triệu"), sau là một số ("nửa triệu hai"), sau là
 *     danh từ ĐẾM ("nửa triệu người") hoặc đơn vị lóng không đứng cuối ("nửa củ khoai"): các ca đó giữ luật cũ (chưa đọc/không
 *     phải tiền). "nửa k"/"nửa nghìn" không đọc (hỏi). Không dấu: "nua" + trieu/cu/tr — không "ty"/"ti" (= "tí").
 *
 * ═══ Chống đụng nghĩa (năm/nam · sáu/sau · bảy/bay · tám/tạm · ba/bà · tư/từ · một/mốt) ═══
 *   · Một cụm CHỈ được viết lại khi nó có TỪ BẬC SỐ (mười · mươi · trăm · nghìn · ngàn · triệu · tỷ · tỉ) hoặc đứng NGAY
 *     TRƯỚC một đơn vị tiền (k · tr · củ · đồng · đ · vnđ) mà sau đơn vị đó KHÔNG còn từ nào ⇒ "ba người", "sau đó",
 *     "năm 2026", "thu quỹ tháng năm", "Ba đồng ý", "ba k biết" không đổi.
 *   · Câu CÓ DẤU ở bất kỳ đâu ⇒ chỉ nhận từ CÓ DẤU (người gõ có dấu thì "sau" là "sau", không phải "sáu"). Câu KHÔNG DẤU
 *     hoàn toàn ⇒ nhận bảng không dấu. "ty"/"ti" không dấu KHÔNG phải tỷ ("một tí" = một chút) — chỉ "tỷ"/"tỉ" có dấu.
 *   · "năm" ngay sau "mười/mươi" KHÔNG bao giờ là 5 (5 ở đó nói là "lăm"; "năm" hay là năm trời — rà đối kháng S18: "hoạt
 *     động hai mươi năm triệu đồng đã quyên góp" từng ra 25.000.000). Cụm còn đi tiếp ("hai mươi năm nghìn") ⇒ CẢ CỤM mơ hồ,
 *     không tách "năm nghìn" thành số riêng; "năm" đứng cuối cụm ("sau mười năm góp quỹ") ⇒ danh từ, số là "10".
 *   · "một" đứng CUỐI cụm và ngay trước một danh từ chỉ đầu người/kỳ ("hai trăm nghìn MỘT bạn") là "mỗi", không phải chữ
 *     số của đuôi ⇒ không nhập vào cụm — đúng như người gõ số viết "200k một bạn".
 *
 * Hàm thuần, tất định, `bigint`, không float, không LLM. KHÔNG import module nào của domain (tránh vòng import với
 * `vi-normalizer.ts`/`money-parser.ts` — hai module đó gọi file này ở đầu).
 */

import { findDecimalAndHalfRuns } from "./vi-number-words-decimal.js";
import { HEAD_COUNT_NOUNS, PRONOUN_LIKE_PERSON_NOUNS } from "./vi-count-nouns.js";

/** Loại của một từ trong cụm số. */
export type WordKind =
  | { readonly k: "digit"; readonly v: bigint } // một..chín (và "mot" không dấu cũng là "mốt")
  | { readonly k: "zero" } // không
  | { readonly k: "ten" } // mười (có dấu) — mở hàng 10..19
  | { readonly k: "tens" } // mươi (có dấu) — hậu tố hàng chục
  | { readonly k: "tenOrTens" } // "muoi" không dấu — mười hay mươi tuỳ vị trí
  | { readonly k: "special"; readonly v: bigint } // mốt 1 · tư 4 · lăm 5 — chỉ đứng sau hàng chục
  | { readonly k: "hundred" } // trăm
  | { readonly k: "dozen" } // chục — "ba chục nghìn" = 30 nghìn (Goppy; NeMo không có)
  | { readonly k: "linh" } // linh · lẻ — số 0 ở hàng chục
  | { readonly k: "mag"; readonly f: bigint }; // nghìn/ngàn · triệu · tỷ/tỉ

const D = (v: bigint): WordKind => ({ k: "digit", v });
const MAG = (f: bigint): WordKind => ({ k: "mag", f });
const THOUSAND = 1_000n;
const MILLION = 1_000_000n;
const BILLION = 1_000_000_000n;

/**
 * Bảng CÓ DẤU — chuyển thể `digit.tsv` (một..chín, "bẩy"), `digit_special.tsv` (mốt · tư · lăm), `zero.tsv` (không),
 * `teen.tsv` (mười), `hundred.tsv` (trăm), `thousands.tsv` (nghìn · triệu · tỉ) + "ngàn" · "tỷ" · "mươi" · "linh"/"lẻ"
 * (hai hằng trong `cardinal.py`). `Object.create(null)` + `hasOwn` khi tra: "constructor"/"__proto__" không phải từ số.
 */
const LEXICON_DIACRITIC: Readonly<Record<string, WordKind>> = Object.freeze(
  Object.assign(Object.create(null) as Record<string, WordKind>, {
    một: D(1n), hai: D(2n), ba: D(3n), bốn: D(4n), năm: D(5n), sáu: D(6n), bảy: D(7n), bẩy: D(7n), tám: D(8n), chín: D(9n),
    không: { k: "zero" }, mười: { k: "ten" }, mươi: { k: "tens" },
    mốt: { k: "special", v: 1n }, tư: { k: "special", v: 4n }, lăm: { k: "special", v: 5n },
    trăm: { k: "hundred" }, chục: { k: "dozen" }, linh: { k: "linh" }, lẻ: { k: "linh" },
    nghìn: MAG(THOUSAND), ngàn: MAG(THOUSAND), triệu: MAG(MILLION), tỷ: MAG(BILLION), tỉ: MAG(BILLION),
  }),
);

/**
 * Bảng KHÔNG DẤU — chỉ dùng khi CẢ CÂU không có một dấu nào. "mot" = một = mốt (cùng giá trị 1, vị trí quyết định vai);
 * "muoi" = mười hoặc mươi (vị trí quyết định); "tu" = tư; "lam" = lăm. KHÔNG có "ty"/"ti" (= "tí/tý" một chút).
 */
const LEXICON_PLAIN: Readonly<Record<string, WordKind>> = Object.freeze(
  Object.assign(Object.create(null) as Record<string, WordKind>, {
    mot: D(1n), hai: D(2n), ba: D(3n), bon: D(4n), nam: D(5n), sau: D(6n), bay: D(7n), tam: D(8n), chin: D(9n),
    khong: { k: "zero" }, muoi: { k: "tenOrTens" },
    tu: { k: "special", v: 4n }, lam: { k: "special", v: 5n },
    tram: { k: "hundred" }, chuc: { k: "dozen" }, linh: { k: "linh" }, le: { k: "linh" },
    nghin: MAG(THOUSAND), ngan: MAG(THOUSAND), trieu: MAG(MILLION),
  }),
);

/**
 * Đơn vị tiền đứng NGAY SAU cụm KHÔNG có từ bậc ⇒ cụm vẫn là tiền ("hai củ", "năm k") — nhưng CHỈ khi sau đơn vị đó không còn
 * một từ nữa (`isTerminalUnit`): "Ba đồng ý" (bố đồng ý) · "ba k biết" (k = không) · "hai củ khoai" · "anh Năm đồng ý" đều là
 * đơn vị GIẢ. Không dấu: "dong" KHÔNG vào tập — nó là đóng/đồng/đông ("anh Nam dong ho" = anh Nam đóng hộ, đo trên câu ví dụ
 * thật của PAY-ON-BEHALF: bản đầu đọc ra 5 đ).
 */
const MONEY_UNIT_AFTER_DIACRITIC = new Set(["k", "tr", "củ", "đồng", "đ", "vnđ", "vnd"]);
const MONEY_UNIT_AFTER_PLAIN = new Set(["k", "tr", "vnd"]);
/** Đơn vị NHÂN đứng sau "X trăm" ⇒ "X trăm" là X×100 của đơn vị đó ("năm trăm k" = 500k), không còn là "N trăm" trần. */
const MULTIPLIER_AFTER = new Set(["k", "tr", "củ"]);

/**
 * Danh từ mà "một" đứng trước nghĩa là "MỖI" ("hai trăm nghìn một bạn", "700k một người"). Tập ĐÓNG; ngoài tập ⇒ "một"
 * là chữ số của đuôi ⇒ luật đuôi ghép hỏi lại (chiều an toàn: "một triệu một nhé" vẫn hỏi 1.000.000 hay 1.100.000).
 */
const PER_NOUNS_DIACRITIC = new Set([
  "người", "bạn", "suất", "cháu", "em", "bé", "con", "đứa", "nhà", "hộ", "phần", "thành", "học", "phụ", "tháng", "tuần", "năm",
  "buổi", "kỳ", "đợt", "lần", "ngày",
]);
const PER_NOUNS_PLAIN = new Set([
  "nguoi", "ban", "suat", "chau", "em", "be", "con", "dua", "nha", "ho", "phan", "thanh", "hoc", "phu", "thang", "tuan", "nam",
  "buoi", "ky", "dot", "lan", "ngay",
]);

/** Câu có dấu tiếng Việt (hoặc đ/Đ) ở bất kỳ đâu ⇒ người gõ có dấu. */
function hasVietDiacritics(text: string): boolean {
  return /[đĐ]/u.test(text) || /[̀-ͯ]/u.test(text.normalize("NFD"));
}

export interface Word {
  readonly text: string; // nguyên văn (đã NFC)
  readonly start: number;
  readonly end: number;
  readonly kind: WordKind | null;
}

/** Một thành phần 0..999 (một "nhóm ba chữ số") mà bộ phân tích nhận ra, từ vị trí i tới `end` (không gồm). */
interface Component {
  readonly end: number;
  readonly value: bigint;
  /** Chỉ "X trăm" (không gì sau) — ở cuối câu là "N trăm" trần (QĐ-10). */
  readonly hundredsOnly: boolean;
  /** "N chục" — ở cuối câu là "N chục" trần: y như dạng chữ số "3 chục", luật cũ coi là mơ hồ ⇒ hỏi. */
  readonly dozenOnly: boolean;
  /** Một chữ số đơn lẻ ("hai"). */
  readonly single: boolean;
  /** Mở bằng số 0 tường minh: "không trăm …" · "linh/lẻ D" — đuôi đầy đủ, không mơ hồ bậc. */
  readonly zeroLed: boolean;
  /** Dạng rút gọn NeMo đọc được nhưng tiền phải HỎI (xem docblock, mục 1). */
  readonly colloquial: boolean;
}

const kindAt = (ws: readonly Word[], i: number): WordKind | null => ws[i]?.kind ?? null;
const isTens = (k: WordKind | null): boolean => k?.k === "tens" || k?.k === "tenOrTens";
const isTen = (k: WordKind | null): boolean => k?.k === "ten" || k?.k === "tenOrTens";
const tieDigit = (k: WordKind | null): bigint | null => (k?.k === "digit" && k.v >= 2n ? k.v : null);

/**
 * Hàng đơn vị SAU hàng chục ("… mươi X"): một..chín, mốt · tư · lăm — **TRỪ "năm"** (như `last_digit` của NeMo).
 * 🔴 Rà đối kháng S18: bản đầu nhận "năm" = 5 ⇒ "hoạt động hai mươi NĂM triệu đồng đã quyên góp" ra 25.000.000. Sau hàng chục,
 * số 5 được nói là "lăm"; "năm" ở đó hay là "năm (year)" ⇒ không đọc (cụm không trọn ⇒ mơ hồ, xem `yearAfterTens`).
 */
function lastDigitAt(ws: readonly Word[], i: number): bigint | null {
  const k = kindAt(ws, i);
  if (k?.k === "special" || (k?.k === "digit" && k.v !== 5n)) return k.v;
  return null;
}

/** "năm" (có dấu/không dấu — kind chữ số 5; "lăm" là kind riêng) đứng ngay sau "mười"/"mươi". */
function yearAfterTens(ws: readonly Word[], i: number): boolean {
  const k = kindAt(ws, i);
  const prev = kindAt(ws, i - 1);
  return k?.k === "digit" && k.v === 5n && (prev?.k === "ten" || prev?.k === "tens" || prev?.k === "tenOrTens");
}

/** Các cách đọc hai chữ số (hoặc một) bắt đầu ở i — KHÔNG gồm "trăm". Trả nhiều ứng viên; bộ phân tích cụm chọn. */
function twoDigitCandidates(ws: readonly Word[], i: number, afterMagnitude: boolean): Component[] {
  const out: Component[] = [];
  const base = { hundredsOnly: false, dozenOnly: false, single: false, zeroLed: false, colloquial: false };
  const k = kindAt(ws, i);
  if (k?.k === "digit") out.push({ ...base, end: i + 1, value: k.v, single: true });
  // "một ngàn MỐT" (NeMo: nghìn + mốt/tư/lăm = hàng trăm) — chỉ sau một bậc; đứng đầu thì "mốt"/"tư" không phải số.
  if (afterMagnitude && k?.k === "special") out.push({ ...base, end: i + 1, value: k.v, single: true });
  // mười · mười X (teen.tsv). "mười năm nghìn" KHÔNG cắt đôi thành "mười | năm nghìn" — cụm không trọn ⇒ mơ hồ cả cụm.
  if (isTen(k)) {
    out.push({ ...base, end: i + 1, value: 10n });
    const n = kindAt(ws, i + 1);
    // teen.tsv: mười một..mười chín, "mười lăm" — KHÔNG "mười năm" (= mười năm trời; rà đối kháng S18).
    if ((n?.k === "digit" && n.v !== 5n) || (n?.k === "special" && n.v === 5n)) out.push({ ...base, end: i + 2, value: 10n + n.v });
  }
  const tie = tieDigit(k);
  if (tie !== null) {
    if (isTens(kindAt(ws, i + 1))) {
      out.push({ ...base, end: i + 2, value: tie * 10n });
      const last = lastDigitAt(ws, i + 2);
      if (last !== null) out.push({ ...base, end: i + 3, value: tie * 10n + last });
    }
    const n = kindAt(ws, i + 1);
    // "hai mốt" · "ba tư" · "hai lăm" — dấu hiệu riêng của hàng đơn vị ⇒ không mơ hồ.
    if (n?.k === "special") out.push({ ...base, end: i + 2, value: tie * 10n + n.v });
    // "bốn ba" · "sáu bảy" — NeMo đọc 43 · 67, tiền thì có thể là KHOẢNG ("sáu bảy trăm nghìn") ⇒ rút gọn, phải hỏi.
    // NeMo loại "năm" ở hàng đơn vị ("năm năm" = năm năm) — giữ đúng như vậy.
    if (n?.k === "digit" && n.v !== 5n) out.push({ ...base, end: i + 2, value: tie * 10n + n.v, colloquial: true });
  }
  // "linh/lẻ D" — chỉ sau một bậc ("một nghìn lẻ một", "một trăm linh năm" đã xử lý trong hàng trăm).
  if (afterMagnitude && k?.k === "linh") {
    const n = kindAt(ws, i + 1);
    if (n?.k === "digit" || (n?.k === "special" && n.v !== 1n)) out.push({ ...base, end: i + 2, value: n.v, zeroLed: true });
  }
  return out;
}

/** Các cách đọc một thành phần 0..999 bắt đầu ở i. `afterMagnitude` ⇒ cho phép "không trăm …" và "linh/lẻ D". */
function componentCandidates(ws: readonly Word[], i: number, afterMagnitude: boolean): Component[] {
  const out: Component[] = [];
  const k = kindAt(ws, i);
  const hundredsDigit = k?.k === "digit" ? k.v : k?.k === "zero" && afterMagnitude ? 0n : null;
  if (hundredsDigit !== null && kindAt(ws, i + 1)?.k === "hundred") {
    const base = hundredsDigit * 100n;
    const zeroLed = hundredsDigit === 0n;
    const h = { single: false, zeroLed, colloquial: false, dozenOnly: false };
    out.push({ ...h, end: i + 2, value: base, hundredsOnly: !zeroLed });
    const j = i + 2;
    const n = kindAt(ws, j);
    // "X trăm linh/lẻ D" (zero.tsv + digit | tư | lăm)
    if (n?.k === "linh") {
      const d = kindAt(ws, j + 1);
      if (d?.k === "digit" || (d?.k === "special" && d.v !== 1n)) out.push({ ...h, end: j + 2, value: base + d.v, hundredsOnly: false });
    }
    // "X trăm mốt/tư" = X10/X40 (NeMo) — rút gọn ⇒ tiền phải hỏi
    if (n?.k === "special" && n.v !== 5n) out.push({ ...h, end: j + 1, value: base + n.v * 10n, hundredsOnly: false, colloquial: true });
    for (const t of twoDigitCandidates(ws, j, false)) {
      // "X trăm D" (một chữ số trần sau trăm): NeMo = X·100 + D·10 ("một trăm hai" = 120) — rút gọn ⇒ hỏi.
      // "X trăm một" NeMo KHÔNG nhận (một không phải hàng chục) ⇒ bỏ.
      if (t.single) {
        if (tieDigit(kindAt(ws, j)) !== null) out.push({ ...h, end: t.end, value: base + t.value * 10n, hundredsOnly: false, colloquial: true });
        continue;
      }
      out.push({ ...h, end: t.end, value: base + t.value, hundredsOnly: false, colloquial: t.colloquial });
    }
    // "X trăm D E" không "mươi" với E thường ("một trăm bốn bảy") đã là rút gọn ở twoDigitCandidates.
  }
  // "N chục" (rà vòng 2 S18): một chữ số + "chục" = N×10. Chỉ dạng này — "hai trăm ba chục", "vài chục" không đọc (mơ hồ/chưa đọc).
  if (k?.k === "digit" && kindAt(ws, i + 1)?.k === "dozen") {
    out.push({ end: i + 2, value: k.v * 10n, hundredsOnly: false, dozenOnly: true, single: false, zeroLed: false, colloquial: false });
  }
  out.push(...twoDigitCandidates(ws, i, afterMagnitude));
  return out;
}

interface Group {
  readonly value: bigint;
  readonly factor: bigint;
  readonly magWord: string;
  readonly colloquial: boolean;
}

/** Một cách đọc TRỌN cụm: các nhóm có bậc (giảm dần) + đuôi không bậc (có thể vắng). */
interface PhraseParse {
  readonly groups: readonly Group[];
  readonly tail: Component | null;
  readonly tailStart: number;
}

/** Mọi cách đọc TRỌN `ws` (tối đa vài chục từ — duyệt hết được). */
function parsePhrases(ws: readonly Word[]): PhraseParse[] {
  const out: PhraseParse[] = [];
  const walk = (i: number, lastFactor: bigint | null, groups: Group[]): void => {
    if (i === ws.length) {
      if (groups.length > 0) out.push({ groups, tail: null, tailStart: i });
      return;
    }
    for (const c of componentCandidates(ws, i, lastFactor !== null)) {
      const next = kindAt(ws, c.end);
      if (next?.k === "mag" && c.value > 0n && (lastFactor === null || next.f < lastFactor)) {
        walk(c.end + 1, next.f, [...groups, { value: c.value, factor: next.f, magWord: ws[c.end]!.text, colloquial: c.colloquial }]);
      }
      if (c.end === ws.length) out.push({ groups, tail: c, tailStart: i });
    }
  };
  walk(0, null, []);
  return out;
}

/** Cách đọc ƯU TIÊN: không rút gọn trước; trong cùng hạng, cách đọc tìm thấy đầu tiên. */
function bestParse(ws: readonly Word[]): PhraseParse | null {
  const all = parsePhrases(ws);
  const isColloquial = (p: PhraseParse) => p.groups.some((g) => g.colloquial) || (p.tail?.colloquial ?? false);
  return all.find((p) => !isColloquial(p)) ?? all[0] ?? null;
}

function sumHead(groups: readonly Group[]): bigint {
  return groups.reduce((acc, g) => acc + g.value * g.factor, 0n);
}

/**
 * Giá trị của CẢ cụm theo ngữ pháp NeMo (cardinal) — `null` khi cụm không phải MỘT số. Dùng cho bộ ca port NeMo; KHÔNG
 * dùng để quyết định tiền (dạng rút gọn vẫn cho giá trị ở đây, nhưng `rewriteViNumberWords` đánh dấu mơ hồ).
 * `colloquial` = cách đọc này dùng dạng rút gọn mà tiền phải hỏi.
 */
export function readViCardinal(phrase: string): { readonly value: bigint; readonly colloquial: boolean } | null {
  const toks = tokenizeWords(phrase.normalize("NFC")).filter((w) => w.kind !== undefined);
  if (toks.length === 0 || toks.some((w) => w.kind === null)) return null;
  const ws = toks as readonly Word[];
  const p = bestParse(ws);
  if (p === null) return null;
  const head = sumHead(p.groups);
  const colloquial = p.groups.some((g) => g.colloquial) || (p.tail?.colloquial ?? false);
  if (p.tail === null) return { value: head, colloquial };
  if (p.groups.length === 0) return { value: p.tail.value, colloquial };
  const lastFactor = p.groups[p.groups.length - 1]!.factor;
  if (p.tail.single) {
    // NeMo: "một ngàn chín" = 1.900 (chữ số trần sau NGHÌN là hàng trăm); sau triệu/tỷ NeMo không nhận; "năm" bị loại.
    const d = p.tail.value;
    const isNam = ws[p.tailStart]?.kind?.k === "digit" && d === 5n; // "năm" loại (năm = năm tháng), "lăm" thì nhận
    if (lastFactor !== THOUSAND || isNam) return null;
    return { value: head + d * 100n, colloquial: true };
  }
  return { value: head + p.tail.value, colloquial };
}

/** Kết quả viết lại một câu. */
export interface ViNumberWordsRewrite {
  /** Câu sau khi thay các cụm số chữ ĐỌC ĐƯỢC bằng chữ số (phần còn lại giữ nguyên). */
  readonly text: string;
  /**
   * Cụm số chữ (có từ bậc hoặc đứng trước đơn vị tiền) mà KHÔNG đọc được thành một cách duy nhất — dạng rút gọn, sai ngữ
   * pháp, bậc ghép. Khác `null` ⇒ người gọi coi cả câu là MƠ HỒ (hỏi lại), không đọc nửa cụm ("sáu bảy trăm nghìn" KHÔNG
   * được thành 700.000).
   */
  readonly ambiguousRun: string | null;
  /**
   * 🔴 Rà vòng 2 S18 — cụm có DẤU HIỆU số tiền bằng chữ mà bộ này KHÔNG đọc (và không được đoán): một TỪ ƯỚC LƯỢNG
   * (`vài · mấy · dăm · nửa · mươi · hàng`) đứng ngay trước một từ bậc (chục/trăm/nghìn/ngàn/triệu/tỷ), một đơn vị tiền, hoặc
   * một cụm số chữ ("vài ba trăm nghìn" = khoảng 200–300 nghìn — KHÔNG được đọc thành 300.000). Khác `null` ⇒ người gọi KHÔNG
   * được âm thầm bỏ qua nó: câu còn một số tiền khác đọc được ⇒ cả câu mơ hồ (hỏi, không chọn số còn lại); không số nào ⇒
   * không đọc được (S17 hỏi lại có gợi ý). Trước chốt này "mua rau ba chục nghìn, còn dư năm trăm nghìn" ra 500.000 — cụm không
   * đọc được trở nên VÔ HÌNH và lưới nhiều-giá-trị mù một nửa.
   */
  readonly unreadRun: string | null;
}

/**
 * Số-có-đơn-vị đứng NGAY TRƯỚC ("1 triệu ", "1tr", "500k ") — một số theo sau là ĐUÔI SỐ GHÉP ("1 triệu 2": 1.200.000 hay
 * 1.000.002?). Chuyển từ `money-parser.ts` về đây (nguồn DUY NHẤT, money-parser import lại) vì bộ viết lại dùng CHÍNH vị-từ này
 * cho dạng chữ: "1tr hai" từng ra 1.000.000 tự tin (có từ develop) trong khi "1tr2" hỏi.
 */
export const COMPOUND_HEAD_BEFORE_NUMBER_RE =
  /\d\s*(?:nghìn|nghin|ngàn|ngan|triệu|trieu|củ|cu|tỉ|tỷ|ti|ty|k|tr)\s*$/iu;

/** Từ ngay sau "năm" khiến "năm" là danh từ NĂM ("500k năm nay" = 500k năm nay), không phải chữ số 5 của đuôi. */
const YEAR_CONTEXT_DIACRITIC = new Set(["nay", "ngoái", "trước", "sau", "tới", "rồi", "qua", "học", "mới"]);
const YEAR_CONTEXT_PLAIN = new Set(["nay", "ngoai", "truoc", "sau", "toi", "roi", "qua", "hoc", "moi"]);

/**
 * 🔴 Rà vòng 4 — DANH TỪ ĐẾM (tập ĐÓNG): từ ước lượng + bậc + một trong các danh từ này là thành ngữ đếm SỐ LƯỢNG ("hàng chục
 * người", "vài trăm lượt"), không phải tiền ⇒ không phải cụm tiền chưa đọc. Hai tiếng thì khai CẢ CỤM ("học sinh", "ý kiến").
 *
 * ⚠️ THIẾU một danh từ ở đây ⇒ câu có tiền rõ bị HỎI THỪA (an toàn). ĐỪNG BAO GIỜ đảo lại thành "danh sách đơn vị/từ tiền mới là
 * tín hiệu": vòng 2–3 làm đúng thế, và mỗi từ tiền thiếu ("bạc", "tiền", "cắc") là một lần số tiền còn lại lọt thẳng vào phiếu.
 * "con" (con gà / con = đứa con) cố ý VẮNG — "hàng chục con gà, thu 200k" hỏi lại.
 */
/** AI-INTERP N3: tập NGƯỜI từ từ vựng chung + "em"/"hộ"/"nhà" ("con" cố ý vắng — trên); phần RIÊNG của bộ viết lại: đơn vị/vật đếm. */
const PERSON_COUNT_NOUNS = [...HEAD_COUNT_NOUNS, ...PRONOUN_LIKE_PERSON_NOUNS.filter((n) => n.vi !== "con")];
const COUNT_NOUNS_DIACRITIC = new Set([
  ...PERSON_COUNT_NOUNS.map((n) => n.vi),
  "lớp", "nhóm", "đội", "lần", "lượt", "năm", "tháng", "tuần", "ngày", "giờ", "phút", "giây", "cuộc", "buổi", "ý kiến", "email",
  "tin nhắn", "câu", "trang", "cái", "chiếc", "quả", "trứng", "bài", "cuốn", "quyển", "ảnh", "lá", "kg", "cân", "lít", "mét", "km",
  "dân", "view", "like", "follower", "lượt xem", // S29 rà vòng 3: "nửa triệu dân/view" là SỐ LƯỢNG
]);
const COUNT_NOUNS_PLAIN = new Set([
  ...PERSON_COUNT_NOUNS.map((n) => n.plain),
  "lop", "nhom", "doi", "lan", "luot", "nam", "thang", "tuan", "ngay", "gio", "phut", "giay", "cuoc", "buoi", "y kien", "email",
  "tin nhan", "cau", "trang", "cai", "chiec", "qua", "trung", "bai", "cuon", "quyen", "anh", "la", "kg", "can", "lit", "met", "km",
  "dan", "view", "like", "follower", "luot xem",
]);
/**
 * Từ chỉ TIỀN (không phải danh từ đếm): luôn là tín hiệu. Với mặc định mới, tập này KHÔNG phải điều kiện an toàn (bỏ một từ ở
 * đây, cụm vẫn là tín hiệu vì từ đó không nằm trong tập danh từ đếm) — nó chặn một người sau lỡ thêm "tiền" vào tập đếm.
 */
const MONEY_NOUNS_DIACRITIC = new Set(["bạc", "tiền", "cắc", "đồng", "xu"]);
const MONEY_NOUNS_PLAIN = new Set(["bac", "tien", "cac", "dong", "xu"]);

/** Từ ƯỚC LƯỢNG số lượng (có dấu / không dấu). Tập ĐÓNG; đứng một mình hay trước danh từ ("vài người", "nửa lớp") thì vô hại. */
const QUANTIFIERS_DIACRITIC = new Set(["vài", "mấy", "dăm", "nửa", "mươi", "hàng"]);
const QUANTIFIERS_PLAIN = new Set(["vai", "may", "dam", "nua", "hang"]);
const isOrderKind = (k: WordKind | null | undefined): boolean => k?.k === "mag" || k?.k === "hundred" || k?.k === "dozen";


/** Phần nguyên "A" trước "phẩy": "không" hoặc MỘT thành phần 0..999 đọc trọn, không rút gọn, không phải "N trăm"/"N chục" trần. */
function decimalIntegerOf(ws: readonly Word[]): bigint | null {
  if (ws.length === 1 && ws[0]!.kind?.k === "zero") return 0n;
  const p = bestParse(ws);
  const t = p?.tail;
  if (p === null || p.groups.length > 0 || t === null || t === undefined) return null;
  if (t.colloquial || t.hundredsOnly || t.dozenOnly) return null;
  return t.value;
}

/**
 * Chia câu thành từ chữ cái (và biết vị trí). Mỗi từ mang `kind` từ bảng phù hợp với chế độ dấu của CẢ câu; `undefined`
 * cho token không phải chữ (số, dấu câu) để biết chỗ ngắt cụm.
 */
export interface Token {
  readonly text: string;
  readonly start: number;
  readonly end: number;
  /** `undefined` = không phải từ chữ cái (số, dấu câu); `null` = từ không phải từ số. */
  readonly kind: WordKind | null | undefined;
}

function tokenizeWords(text: string): Token[] {
  const lexicon = hasVietDiacritics(text) ? LEXICON_DIACRITIC : LEXICON_PLAIN;
  const out: Token[] = [];
  for (const m of text.matchAll(/\p{L}+|[^\s\p{L}]+/gu)) {
    const tok = m[0];
    const start = m.index ?? 0;
    const isWord = /^\p{L}+$/u.test(tok);
    const key = tok.toLowerCase();
    const kind = isWord ? (Object.hasOwn(lexicon, key) ? lexicon[key]! : null) : undefined;
    out.push({ text: tok, start, end: start + tok.length, kind });
  }
  return out;
}

/** Từ được phép MỞ một cụm số: chữ số hoặc "mười". ("trăm nghìn", "mốt", "tư", "không", "lẻ" đứng đầu không phải số.) */
const canStart = (k: WordKind | null | undefined): boolean => k?.k === "digit" || k?.k === "ten" || k?.k === "tenOrTens";
/** Cụm có TỪ BẬC SỐ — điều kiện để viết lại khi không có đơn vị tiền theo sau. */
const hasOrderWord = (ws: readonly Word[]): boolean =>
  ws.some((w) => w.kind?.k === "mag" || w.kind?.k === "hundred" || w.kind?.k === "dozen" || w.kind?.k === "ten" || w.kind?.k === "tens" || w.kind?.k === "tenOrTens");

/**
 * Viết lại MỘT cụm đã đọc được thành chữ số — `null` ⇒ mơ hồ. `unitAfter` = từ ngay sau cụm (đã hạ chữ thường) hoặc "".
 */
function emitRun(ws: readonly Word[], unitAfter: string): string | null {
  const p = bestParse(ws);
  if (p === null || p.groups.some((g) => g.colloquial) || (p.tail?.colloquial ?? false)) return null;
  const tail = p.tail;
  const hundredWord = (t: Component) => ws.slice(p.tailStart, t.end).find((w) => w.kind?.k === "hundred")!.text;
  const dozenWord = (t: Component) => ws.slice(p.tailStart, t.end).find((w) => w.kind?.k === "dozen")!.text;
  if (p.groups.length === 0) {
    const t = tail!;
    // "X trăm" trần giữ nguyên dạng "N trăm" (QĐ-10: hỏi, 200.000 mời trước) — trừ khi đơn vị NHÂN theo sau ("năm trăm k").
    if (t.hundredsOnly && !MULTIPLIER_AFTER.has(unitAfter)) return `${t.value / 100n} ${hundredWord(t)}`;
    // "N chục" trần giữ dạng "N chục" ⇒ luật cũ `AMBIGUOUS_MAGNITUDE_AFTER_NUMBER_RE` hỏi, y như người gõ "3 chục".
    if (t.dozenOnly && !MULTIPLIER_AFTER.has(unitAfter)) return `${t.value / 10n} ${dozenWord(t)}`;
    return `${t.value}`;
  }
  const head = sumHead(p.groups);
  const last = p.groups[p.groups.length - 1]!;
  const headText = `${head / last.factor} ${last.magWord}`;
  if (tail === null) return headText;
  // Đuôi ĐẦY ĐỦ ⇒ một giá trị. Sau "nghìn": mọi đuôi trừ một chữ số trần ("một nghìn hai" = 1.200 hay 1.002?).
  // Sau "triệu"/"tỷ": chỉ đuôi mở bằng số 0 tường minh ("hai triệu không trăm linh năm") — "một triệu hai trăm năm mươi"
  // hay được nói với nghĩa 1.250.000 (bỏ chữ "nghìn") ⇒ để luật đuôi ghép cũ hỏi.
  const complete = !tail.dozenOnly && (last.factor === THOUSAND ? !tail.single : tail.zeroLed);
  if (complete) return `${head + tail.value}`;
  const tailText = tail.hundredsOnly
    ? `${tail.value / 100n} ${hundredWord(tail)}`
    : tail.dozenOnly
      ? `${tail.value / 10n} ${dozenWord(tail)}`
      : `${tail.value}`;
  return `${headText} ${tailText}`;
}

/**
 * Tìm các CỤM số viết bằng chữ trong câu và viết lại thành chữ số. Câu không có cụm nào đủ điều kiện ⇒ trả NGUYÊN câu.
 * Token chữ số của chính nó ("200 nghìn", "1 triệu") chạy lại KHÔNG đổi (từ bậc đứng sau chữ số không mở được cụm) —
 * `extractMoneyCandidates` viết lại câu rồi gọi `parseVndAmountMinor` (cũng viết lại) trên từng token đó.
 * ⚠️ Chế độ dấu tính trên CẢ câu: câu mà dấu duy nhất nằm trong cụm vừa viết lại sẽ thành câu không dấu nếu chạy lại —
 * nên người gọi viết lại MỘT lần trên chữ gốc (`resolveMoneySlot` truyền span GỐC cho cả hai bộ đọc), không xích hai lần.
 */
export function rewriteViNumberWords(input: string): ViNumberWordsRewrite {
  const text = (input ?? "").normalize("NFC");
  const toks = tokenizeWords(text);
  const plain = !hasVietDiacritics(text);
  const unitSet = plain ? MONEY_UNIT_AFTER_PLAIN : MONEY_UNIT_AFTER_DIACRITIC;
  const perNouns = plain ? PER_NOUNS_PLAIN : PER_NOUNS_DIACRITIC;
  let out = "";
  let cursor = 0;
  let ambiguousRun: string | null = null;
  let unreadRun: string | null = null;
  const quantifiers = plain ? QUANTIFIERS_PLAIN : QUANTIFIERS_DIACRITIC;
  const isAdjacent = (a: Token, b: Token | undefined): b is Token => b !== undefined && /^\s*$/u.test(text.slice(a.end, b.start));
  const isQuantifierBefore = (idx: number): boolean => {
    const prev = toks[idx - 1];
    return prev !== undefined && prev.kind !== undefined && quantifiers.has(prev.text.toLowerCase()) && isAdjacent(prev, toks[idx]);
  };
  const countNouns = plain ? COUNT_NOUNS_PLAIN : COUNT_NOUNS_DIACRITIC;
  const moneyNouns = plain ? MONEY_NOUNS_PLAIN : MONEY_NOUNS_DIACRITIC;
  const wordAt = (idx: number): string => {
    const w = toks[idx];
    return w !== undefined && w.kind !== undefined && isAdjacent(toks[idx - 1]!, w) ? w.text.toLowerCase() : "";
  };
  /** Danh từ đếm (một hoặc hai tiếng) bắt đầu ở `idx`, liền ngay sau từ trước nó. */
  const countNounAt = (idx: number): boolean => {
    const one = wordAt(idx);
    if (one === "") return false;
    const two = wordAt(idx + 1);
    return countNouns.has(one) || (two !== "" && countNouns.has(`${one} ${two}`));
  };
  const moneyNounAt = (idx: number): boolean => moneyNouns.has(wordAt(idx));
  const replacements = findDecimalAndHalfRuns(toks, {
    plain,
    integerOf: decimalIntegerOf,
    isOrderKind,
    isAdjacent,
    unitAfter: (w) => unitSet.has(w) || MULTIPLIER_AFTER.has(w),
    perNouns,
    countNounAt,
    moneyNounAt,
  });
  const replacementAt = new Map(replacements.map((r) => [r.start, r]));
  // Từ ước lượng + từ bậc / đơn vị tiền ("vài trăm nghìn", "một nửa triệu", "mấy củ") — những từ bậc này không mở được cụm nên vòng
  // dưới không bao giờ thấy chúng; ghi nhận ở đây để chúng không VÔ HÌNH.
  for (let q = 0; q < toks.length && unreadRun === null; q += 1) {
    const t = toks[q]!;
    const next = toks[q + 1];
    if (replacementAt.has(q)) continue; // S29: "nửa triệu" đọc được ⇒ không phải cụm chưa đọc
    if (t.kind === undefined || !quantifiers.has(t.text.toLowerCase()) || !isAdjacent(t, next) || next.kind === undefined) continue;
    // "mươi" vừa là từ ước lượng ("mươi nghìn") vừa là hậu tố hàng chục ("hai trăm năm MƯƠI nghìn") — sau một từ số thì là hậu tố.
    const prev = toks[q - 1];
    if (t.kind !== null && prev !== undefined && prev.kind !== null && prev.kind !== undefined && isAdjacent(prev, t)) continue;
    const nextKey = next.text.toLowerCase();
    if (unitSet.has(nextKey) || MULTIPLIER_AFTER.has(nextKey)) {
      unreadRun = text.slice(t.start, next.end); // "mấy củ", "vài k"
      continue;
    }
    if (!isOrderKind(next.kind)) continue;
    let e = q + 1;
    while (isAdjacent(toks[e]!, toks[e + 1]) && isOrderKind(toks[e + 1]!.kind)) e += 1;
    // 🔴 Rà vòng 4 — MẶC ĐỊNH LÀ TÍN HIỆU. Từ ước lượng + bậc LUÔN là cụm tiền chưa đọc, TRỪ khi ngay sau là một DANH TỪ ĐẾM
    // trong tập đóng (`countNounAt`): "hàng chục NGƯỜI", "vài trăm LƯỢT". Vòng 3 làm ngược lại (chỉ báo khi thấy đơn vị tiền)
    // ⇒ "vài triệu BẠC, còn 500k" ra 500.000 — mỗi từ chỉ tiền thiếu trong danh sách là một lỗ. Nay thiếu một danh từ đếm ⇒ chỉ
    // HỎI THỪA.
    if (!moneyNounAt(e + 1) && countNounAt(e + 1)) continue;
    unreadRun = text.slice(t.start, toks[e]!.end);
  }
  const yearContext = plain ? YEAR_CONTEXT_PLAIN : YEAR_CONTEXT_DIACRITIC;
  const afterUnitNumber = (idx: number): boolean => COMPOUND_HEAD_BEFORE_NUMBER_RE.test(text.slice(0, toks[idx]!.start));
  let i = 0;
  while (i < toks.length) {
    // S29: đoạn "phẩy"/"chấm"/"nửa" đã quyết TRỌN (viết lại · mơ hồ · không phải tiền) — không đọc lại nửa nào của nó.
    const rep = replacementAt.get(i);
    if (rep !== undefined) {
      if (rep.kind === "ambiguous") ambiguousRun ??= text.slice(toks[rep.start]!.start, toks[rep.end - 1]!.end);
      if (rep.kind === "unread") unreadRun ??= text.slice(toks[rep.start]!.start, toks[rep.end - 1]!.end);
      if (rep.kind === "rewrite") {
        out += text.slice(cursor, toks[rep.start]!.start) + rep.text;
        cursor = toks[rep.end - 1]!.end;
      }
      i = rep.end;
      continue;
    }
    // "2tr TƯ" · "1tr MỐT": mốt/tư/lăm không mở được cụm — trừ ngay sau số-có-đơn-vị, nơi chúng là đuôi ghép.
    // Chỉ câu CÓ DẤU: không dấu "tu" là "từ", "lam" là "làm" ("300k tu quy" = 300k từ quỹ — câu thật của EXP-F-NOALLOC).
    const specialTail = !plain && toks[i]!.kind?.k === "special" && afterUnitNumber(i);
    if (!canStart(toks[i]!.kind) && !specialTail) {
      i += 1;
      continue;
    }
    // Cụm = các từ SỐ liên tiếp, chỉ cách nhau bởi khoảng trắng (dấu câu/chữ số/từ khác ⇒ ngắt).
    let j = i + 1;
    while (j < toks.length && toks[j]!.kind !== null && toks[j]!.kind !== undefined && /^\s*$/u.test(text.slice(toks[j - 1]!.end, toks[j]!.start))) j += 1;
    let run = toks.slice(i, j) as Word[];
    const after = toks[j];
    const adjacent = after !== undefined && /^\s*$/u.test(text.slice(run[run.length - 1]!.end, after.start));
    const nextWord = adjacent ? after.text.toLowerCase() : "";
    // "… MỘT bạn" = "mỗi bạn": "một" cuối cụm trước danh từ chỉ đầu người/kỳ không phải chữ số của đuôi.
    const lastWord = run[run.length - 1]!.text.toLowerCase();
    if (run.length > 1 && (lastWord === "một" || (plain && lastWord === "mot")) && perNouns.has(nextWord)) run = run.slice(0, -1);
    // "năm" CUỐI cụm ngay sau "mười/mươi", và sau nó KHÔNG phải đơn vị tiền ⇒ danh từ năm ("sau mười năm góp quỹ" = sau 10 năm):
    // không nhập vào số. Còn đi tiếp (bậc, đơn vị: "hai mươi năm nghìn/triệu/k") thì KHÔNG tách — cả cụm không đọc trọn ⇒ mơ hồ,
    // để "năm nghìn"/"năm triệu" không bao giờ thành một số tiền riêng đứng cạnh.
    if (run.length === j - i && run.length > 1 && yearAfterTens(run, run.length - 1) && !unitSet.has(nextWord) && !MULTIPLIER_AFTER.has(nextWord)) {
      run = run.slice(0, -1);
    }
    const unitAfter = run.length === j - i ? nextWord : "";
    const afterUnit = toks[j + 1];
    const isTerminalUnit = !(afterUnit !== undefined && afterUnit.kind !== undefined && /^\s*$/u.test(text.slice(after!.end, afterUnit.start)));
    // Từ số bằng chữ NGAY SAU số-có-đơn-vị ("1tr hai") ⇒ viết thành chữ số để luật ĐUÔI GHÉP cũ hỏi, y như "1tr 2". Trừ khi nó là
    // SỐ LƯỢNG của danh từ theo sau ("1tr hai người", "200k hai bạn") hoặc "năm" là danh từ năm ("500k năm nay").
    const soleNam = run.length === 1 && run[0]!.kind?.k === "digit" && run[0]!.kind.v === 5n;
    // Câu KHÔNG DẤU: chỉ khi từ số đứng CUỐI cụm từ ("1tr hai", "1tr hai.") — "300k sau do" (sau đó) · "200k ba me" không phải đuôi.
    const compoundTail =
      afterUnitNumber(i) && !perNouns.has(nextWord) && !(soleNam && yearContext.has(nextWord)) && (!plain || !(adjacent && after.kind !== undefined) || run.length !== j - i);
    if (specialTail && run.length === 1 && compoundTail) {
      out += text.slice(cursor, run[0]!.start) + (run[0]!.kind as { v: bigint }).v.toString();
      cursor = run[0]!.end;
      i += 1;
      continue;
    }
    if ((hasOrderWord(run) || (unitSet.has(unitAfter) && isTerminalUnit)) && isQuantifierBefore(i)) {
      // "vài ba trăm nghìn" = KHOẢNG 200–300 nghìn: cụm đọc được nhưng từ ước lượng đứng trước ⇒ không đọc, không đoán.
      unreadRun ??= text.slice(toks[i - 1]!.start, run[run.length - 1]!.end);
    } else if (hasOrderWord(run) || (unitSet.has(unitAfter) && isTerminalUnit) || compoundTail) {
      const emitted = emitRun(run, unitAfter);
      if (emitted === null) {
        ambiguousRun ??= text.slice(run[0]!.start, run[run.length - 1]!.end);
      } else {
        out += text.slice(cursor, run[0]!.start) + emitted;
        cursor = run[run.length - 1]!.end;
      }
    }
    i = i + run.length;
  }
  out += text.slice(cursor);
  return { text: out, ambiguousRun, unreadRun };
}
